import * as React from "react";
import {InputDialogBase} from "../../Dialogs/InputDialogBase";

export type AbsCodeChoice = 'register' | 'host-in-azure';

export interface AbsCodeChoiceProps extends React.Props<AbsCodeChoicePanel>{
}

export interface AbsCodeChoiceState {
  choice: AbsCodeChoice;
}
export class AbsCodeChoicePanel extends React.Component<AbsCodeChoiceProps, AbsCodeChoiceState> {
  constructor(props: AbsCodeChoiceProps) {
    super(props);
    this.state = { choice: 'host-in-azure'};
  }

  private chooseOption(x: React.FormEvent<HTMLInputElement>) {
    this.setState({choice: x.target['value']});
  }

  public render(): JSX.Element {
    return (
      <div className="dialog-panel abs-code-choice-panel">
        <h2>Create an SDK bot</h2>
        <div className="choice">
          <input type='radio' 
            name="choice" 
            value="host-in-azure"
            id='abs-code-choice-host-in-azure'
            checked={this.state.choice === 'host-in-azure'}
            onChange={x => this.chooseOption(x)}
            />
          <label htmlFor='abs-code-choice-host-in-azure'>Create a new SDK bot hosted in Microsoft Azure</label>
        </div>
        <div className="choice">
          <input type='radio' 
            name="choice" 
            value='register'
            id='abs-code-choice-register'
            checked={this.state.choice === 'register'}
            onChange={x => this.chooseOption(x)}
            />
          <label htmlFor='abs-code-choice-register'>Register an existing bot built using <a href="//aka.ms/bf-createsdkbot" target="_blank">Bot Builder SDK</a>.</label>
        </div>
        <div className="button-panel">
            <button type="button" className="cancel-button">Cancel</button>
            <button type="button" className="ok-button default-button">Ok</button>
        </div>
        
      </div>);
  }
}


// WEBPACK FOOTER //
// ./Client/v4/Views/AbsCodeChoicePanel.tsx